import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { split } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import App from "components/app/App";
import { AppConfig } from 'config/app';
import { getCookie } from 'lib/utils/cookie';
import "rc-time-picker/assets/index.css";
import * as React from "react";
import { ApolloProvider } from 'react-apollo';
import { CookiesProvider } from "react-cookie";
import "react-day-picker/lib/style.css";
import * as ReactDOM from "react-dom";
import { StripeProvider } from "react-stripe-elements";
import "react-toastify/dist/ReactToastify.css";
import "./assets/style/bootstrap.css";
import "./assets/style/global-styles.css";
import "./assets/style/isotope-table.css";
import "./assets/style/overrides/rc-time-picker.css";
import { stripeConfig } from "./config/stripe";


// WS Link variables
let cache;
let httpLink;
let wsLink;

// Test client
if (AppConfig.hostUrl === 'https://test.isotopeticketing.com') {

  // WS link setup
  cache = new InMemoryCache();
  httpLink = new HttpLink({
    uri: 'https://api-test.isotopeticketing.com/'
  });
  wsLink = new WebSocketLink({
    uri: 'wss://api-test.isotopeticketing.com:8081/',
    options: {
      reconnect: true,
      connectionParams: {
        jwtToken: getCookie("token")
      },
      timeout: 100000000
    }
  });

}
// Local client
else if (AppConfig.hostUrl === 'http://localhost:3000') {

  // WS link setup
  cache = new InMemoryCache();
  httpLink = new HttpLink({
    uri: 'http://localhost:8081/'
  });
  wsLink = new WebSocketLink({
    uri: 'ws://localhost:8081/',
    options: {
      reconnect: true,
      connectionParams: {
        jwtToken: getCookie("token")
      },
      timeout: 100000000
    }
  });

}
// Production client
else {

  // WS link setup
  cache = new InMemoryCache();
  httpLink = new HttpLink({
    uri: 'https://api.isotopeticketing.com/'
  });
  wsLink = new WebSocketLink({
    uri: 'wss://api.isotopeticketing.com:8081/',
    options: {
      reconnect: true,
      connectionParams: {
        jwtToken: getCookie("token")
      },
      timeout: 100000000
    }
  });

}

// Web socket connection setup
const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
);

// Web socket connection setup
const client = new ApolloClient({
  cache,
  link
})

// Main ReactDOM render!
ReactDOM.render(
  <StripeProvider apiKey={stripeConfig.apiKey}>
    <ApolloProvider client={client}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </ApolloProvider>
  </StripeProvider>,
  document.getElementById("root") as HTMLElement

);






// WEBPACK FOOTER //
// ./src/index.tsx